import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sub-nav-menu" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createBlock(_component_ion_toolbar, {
    color: "background-transparent",
    class: "sub-menu-toolbar",
    mode: "md",
    id: "sub-menu-toolbar"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["sub-menu-chiplet", button.visibilityClass]),
            key: button.name,
            onClick: button.handler
          }, [
            (button.icon || button.src)
              ? (_openBlock(), _createBlock(_component_ion_icon, {
                  key: 0,
                  class: "chiplet-icon",
                  icon: button.icon,
                  src: button.src,
                  mode: "md"
                }, null, 8, ["icon", "src"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}